<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4">
                                    <figure>
                                        <img :src="fund.image" class="w-100" alt="">
                                    </figure>
                                </div>
                                <div class="col-lg-8">
                                    <h3 class="fw-bold">{{fund.name}}</h3>

                                    <div class="row">
                                        <div class="col-6">
                                            <p class="title">Risk Level</p>
                                            <h5 class="text">
                                                <span v-if="fund.risk_level == 3" class="badge badge-danger">HIGH</span>
                                                <span v-else-if="fund.risk_level == 2" class="badge badge-warning">MEDIUM</span>
                                                <span v-else-if="fund.risk_level == 1" class="badge badge-success">LOW</span>
                                                <span v-else>-</span>
                                            </h5>
                                        </div>
                                        <!-- <div class="col-6">
                                            <p class="title">Trade Report</p>
                                            <p class="text">
                                                <a :href="fund.trade_report_file" target="_blank" rel="noopener noreferrer">
                                                    <svg id="file_download_icon" xmlns="http://www.w3.org/2000/svg" width="13.473" height="16" viewBox="0 0 13.473 16">
                                                        <path id="Icon_material-insert-drive-file" data-name="Icon material-insert-drive-file" d="M7.486,3A1.5,1.5,0,0,0,6.007,4.519L6,16.675a1.5,1.5,0,0,0,1.479,1.519H16.4a1.507,1.507,0,0,0,1.486-1.519V7.558L13.431,3Z" transform="translate(-6 -3)" fill="#1b1b1b" opacity="0.5"/>
                                                        <path id="Path_329" data-name="Path 329" d="M0,0,4.558,4.558H1.013A1.013,1.013,0,0,1,0,3.545Z" transform="translate(7.381 0)" fill="#1b1b1b"/>
                                                        <path id="Icon_awesome-long-arrow-alt-down" data-name="Icon awesome-long-arrow-alt-down" d="M4.647,9.936V6.69a.271.271,0,0,0-.271-.271H3.112a.271.271,0,0,0-.271.271V9.936H1.8a.542.542,0,0,0-.383.925L3.361,12.8a.542.542,0,0,0,.766,0L6.07,10.861a.542.542,0,0,0-.383-.925Z" transform="translate(7.243 3.037)" fill="#1b1b1b"/>
                                                    </svg>
                                                </a>
                                            </p>
                                        </div> -->
                                        <div class="col-12">
                                            <p class="title">Strategy</p>
                                            <p class="text">
                                                {{fund.strategy ? fund.strategy : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-12">
                                            <p class="title">
                                                Last updated at : <span class="badge badge-light">{{fund.updated_at | moment}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    
                                    <div class="broker">
                                        <h5 class="mb-3 fw-bold">Choose Broker</h5>
                                        <div class="row">
                                            <div class="col-lg-3" v-for="broker in filterBrokers" :key="broker.id">
                                                <div class="broker-list">
                                                    <input type="radio" name="broker" @click="sendBroker(broker)" :id="'broker'+broker.id">
                                                    <label :for="'broker'+broker.id" class="broker-body">
                                                        <!-- <div class="broker-body"> -->
                                                            <div class="check_img">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 35.294 35.294">
                                                                    <g id="check_icon" transform="translate(-440 -366)">
                                                                        <path id="Path_395" data-name="Path 395" d="M8.585,0H26.709a8.585,8.585,0,0,1,8.585,8.585V26.709a8.585,8.585,0,0,1-8.585,8.585H8.585A8.585,8.585,0,0,1,0,26.709V8.585A8.585,8.585,0,0,1,8.585,0Z" transform="translate(440 366)" fill="#ed1c24"/>
                                                                        <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M6.588,18.758l-6.3-6.3a.97.97,0,0,1,0-1.372L1.656,9.711a.97.97,0,0,1,1.372,0l4.247,4.247,9.1-9.1a.97.97,0,0,1,1.372,0l1.372,1.372a.97.97,0,0,1,0,1.372L7.96,18.758A.97.97,0,0,1,6.588,18.758Z" transform="translate(447.631 371.916)" fill="#fff"/>
                                                                    </g>
                                                                </svg>
                                                            </div>
                                                            <figure>
                                                                <img :src="broker.logo" class="broker-img" alt="">
                                                            </figure>
                                                            <p class="text-center">{{broker.name}}</p>
                                                        <!-- </div> -->
                                                    </label>
                                                </div>
                                            </div>
                                            <p v-if="filterBrokers.length == 0">No Broker available.</p>
                                        </div>
                                    </div>
                                    <div class="">
                                        <button type="button" :disabled="filterBrokers.length == 0" class="btn btn_red my-2" data-toggle="modal" data-target="#chooseBroker">Continue</button>
                                    </div>
                                    <div class="modal fade" id="chooseBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button> -->
                                                    <div class="text-center" v-if="brokerName">
                                                        <h3 class="title">{{brokerName}}</h3>
                                                        <p>Are you sure to choose this Broker?</p>
                                                    </div>
                                                    <div class="text-center" v-else>
                                                        <h3 class="title">Ooppss...</h3>
                                                        <p>Looks like you haven't chosen a broker</p>
                                                    </div>

                                                    <!-- <form @submit.prevent="handleProduct()"> -->
                                                        <div class="row">
                                                            <div class="col-lg-6 mx-auto">
                                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal" v-if="brokerName">No</button>
                                                                    <button type="button" class="btn btn_outline_red m-2" data-dismiss="modal" v-else>Back</button>
                                                                    <button type="submit" v-if="brokerName" @click="completeBroker()" class="btn btn_red">Yes, I'm sure</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    <!-- </form> -->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal fade" id="detailBroker" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                                        <div class="modal-dialog modal-dialog-centered">
                                            <div class="modal-content">
                                                <div class="modal-body">
                                                    <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button> -->
                                                    <div class="text-center">
                                                        <h3 class="title">Trading Account Details</h3>
                                                        <p>Please complete this form to continue!</p>
                                                    </div>

                                                    <div class="broker_info">
                                                        <h6 class="broker_title">Broker you choose:</h6>
                                                        <div class="broker_data">
                                                            <img :src="brokerImage" :alt="brokerImage">
                                                            <p>{{brokerName}}</p>
                                                        </div>
                                                    </div>

                                                    <form @submit.prevent="handleProduct()" class="mx-4">
                                                    <div class="form-group">
                                                        <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                                                    </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <!-- <input type="hidden" v-model="brokerId" v-validate="'required'" name="password" class="form-control field-password" placeholder="Account Number"> -->
                                                                <input type="tel" v-on:keypress="NumbersOnly" v-model="account_number" v-validate="'required'" name="account_number" class="form-control" :class="{ 'is-invalid':errors.has('account_number') }" placeholder="Account number">
                                                                
                                                            </div>
                                                            <div v-if="submitted && errors.has('account_number')" class="text-danger">
                                                                {{errors.first('account_number')?'Account Number is Required':''}}
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <input type="password" v-model="trader_password" autocomplete="off" v-validate="'required'" name="password" class="form-control field-password" :class="{ 'is-invalid':errors.has('password') }" placeholder="Your trading password">
                                                                <!-- <div class="input-group-append show_pass">
                                                                    <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                                                                </div> -->
                                                            </div>
                                                            <div v-if="submitted && errors.has('password')" class="text-danger">
                                                                {{errors.first('password')?'Password is Required':''}}
                                                            </div>
                                                        </div>
                                                        <div class="form-group">
                                                            <div class="input">
                                                                <input type="text" v-model="broker_server" v-validate="'required'" name="broker_server" class="form-control" :class="{ 'is-invalid':errors.has('broker_server') }" placeholder="Broker server">
                                                                
                                                            </div>
                                                            <div v-if="submitted && errors.has('broker_server')" class="text-danger">
                                                                {{errors.first('broker_server')?'Broker Server is Required':''}}
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-6 mx-auto">
                                                                <div class="text-center button d-flex align-items-center justify-content-center">
                                                                    <button type="button" class="btn btn_grey m-2" data-dismiss="modal" v-if="brokerName">Cancel</button>
                                                                    <!-- <button type="button" class="btn btn_outline_red m-2" data-dismiss="modal" v-else>Back</button> -->
                                                                    <button type="submit" v-if="brokerName" class="btn btn_red" :disabled="loading">
                                                                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                                                        <span v-show="!loading">Save</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <dash-footer></dash-footer>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import $ from 'jquery'
import moment from "moment";

export default {
    name: "AllRobot",
    components: {
        DashHeader,
        DashFooter,
        Sidebar,
    },
    data(){
        return{
            user_id: localStorage.getItem('user_id'),
            fund: [],
            brokers:[],
            brokerId: '',
            brokerName: '',
            brokerImage: '',
            account_number : '',
            trader_password : '',
            broker_server : '',
            order: [],
            transaction: [],
            submitted: false,
            loading: false,
            message: '',
            product: {
                investor_id : '',
                broker_choice : '',
                product_id : '',
                product_type : '',
                payment_amount : '',
                currency : '',
                status : '',
            }
        }
    },
    computed: {
        filterBrokers(){
            return this.brokers.filter(item => item.is_active == true)
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        }
    },
    async mounted(){
        window.scrollTo(0,0)
        
        await axios.get(`investor/fundmanager/${this.$route.params.id}`)
        .then(response => {
            // console.log('Fund Manager All: ', response.data.data)
            this.fund = response.data.data
        }).catch(() => {
            // console.log('Error Fund Manager: ', err.response)
        })
        await axios.get(`investor/fundmanager/${this.$route.params.id}/brokerchoice`)
        .then(response => {
            // console.log('Fund Manager Broker: ', response.data.data)
            this.brokers = response.data.data
        }).catch(() => {
            // console.log('Error broker: ', err.response)
        })
        await axios.get(`investor/${localStorage.user_id}/pendingorder/`)
        .then(response => {
            var list = response.data.data
            for (let i = 0; i < list.length; i++) {
                if (list[i].product_id == this.$route.params.id) {
                    this.order = list[i]
                    // console.log('This Pending Order: ', this.order)
                }
            }
            
        }).catch(() => {
            // console.log('Error Pending Order: ', err.response)
        })
    },
    methods: {
        NumbersOnly(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        sendBroker(broker){
            // localStorage.setItem('transaction_id', this.order.id)
            this.brokerId = broker.id
            this.brokerName = broker.name
            this.brokerImage = broker.logo
        },
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        completeBroker(){
            $('#chooseBroker').modal('hide')
            $('#detailBroker').modal('show')
        },
        handleProduct(){
            this.submitted = true
            this.loading = true
            this.message = ''
            let data = new FormData()
            data.append('investor_id', this.user_id)
            data.append('broker_choice', this.brokerId)
            data.append('account_number', this.account_number)
            data.append('trader_password', this.trader_password)
            data.append('broker_server', this.broker_server)
            // data.append('broker_account_id', this.brokerId)
            data.append('product_id', this.fund.id)
            data.append('product_type', 'FUND_MANAGER')

            this.$validator.validateAll().then(isValid => {
                if(isValid){
                    // axios.put(`transaction/${localStorage.transaction_id}/`, data)
                    axios.put(`investor/transaction/${localStorage.transaction_id}/broker-choice/`, data)
                    .then(() => {
                        this.submitted = false
                        this.loading = false
                        // console.log(response);
                        $('#detailBroker').modal('hide')
                        // window.open('https://bithouse.id', '_blank')
                        this.$router.push(`detail/${this.brokerId}`)
                    }).catch((err) => {
                        this.loading = false
                        // console.log(err.response);
                        this.message = 
                        (err.response && err.response.data) ||
                        err.message ||
                        err.toString();
                    })
                } else{
                    this.loading = false
                }
            });
        },
        handleBroker(){
            $('#chooseBroker').modal('hide')
            localStorage.setItem('transaction_id', this.order.id)
            this.$router.push(`detail/${this.brokerId}`)
        }
    }
}
</script>

<style>
.content-wrapper{
    background: transparent !important;
}
.card.available-robot__card{
    border-radius: 25px;
}
.myrobot-card__heading {
    font-weight: bold;
    font-size: 18px;
}
.myrobot-card__text {
    color: rgba(0, 0, 0, 0.6);
    font-weight: bold;
    font-size: 12px;
    /* margin-top: 5px; */
}
.myrobot-card__value {
    font-weight: bold;
    margin-top: -15px;
    font-size: 12px;
}
button.myrobot-card__button {
    border-radius: 25px;
    width: 100%;
    font-weight: 500;
    font-size: 15px;
}
.myrobot-card__images {
    width: 190px;
    height: 178px;
    object-fit: cover;
    margin-bottom: 15px;
}
.form-group .input .input-group-append{
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(0, -50%);
    width: 40px;
    height: 90%;
    font-size: 18pt;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--grey);
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 1;
}

.broker_info{
    background: #f5f5f5;
    padding: 10px 20px 20px;
    margin: 10px 20px 30px;
    border-left: 3px solid var(--red);
}
.broker_info .broker_title{
    color: var(--grey);
    font-weight: 500;
}
.broker_info .broker_data{
    display: flex;
    align-items: center;
}
.broker_info .broker_data img{
    margin-right: 14px;
    width: 60px;
    height: auto;
}
.broker_info .broker_data p{
    font-weight: 600;
    color: var(--red);
    font-size: 20pt;
    margin: 0;
}
/* .broker .broker-list{
    text-decoration: none;
    color: var(--dark-grey);
}
.broker a.broker-list:hover > .broker-body{
    border: 2px solid var(--red);
}
.broker .broker-list .broker-body{
    border: 2px solid rgb(168, 168, 168);
    background: white;
    padding: 10px;
    border-radius: 10px;
    transition: all 0.3s ease;
}
.broker .broker-list .broker-body figure{
    width: 100%;
    height: 80px;
}
.broker .broker-list .broker-img{
    width: 100%;
    height: 100%;
    object-fit: cover;
} */
</style>